import React from 'react';
import {Navigate} from 'react-router-dom'
import Dashboard from '../pages/Dashboard';
import Campaign from '../pages/Campaign';
import ProjectList from '../pages/ProjectList';
// import Settings from '../pages/UserProfilePage/Settings';
import Settings from '../pages/settings/Settings'
import CreateProject from '../pages/CreateProject';
import CampaignDetail from '../pages/CampaignDetail';
import CampaignEdit from '../pages/CampaignEdit';
import NewCampaign from '../pages/NewCampaign';
import Vendor from '../pages/vendor/Vendor';
import ProjectDetail from '../pages/ProjectDetail';
import VendorBidRequest from '../pages/vendor/VendorBidRequest';
import InContextPreview from '../pages/InContextPreview';
import VendorEdit from '../pages/vendor/VendorEdit';
import VenderAddPriceList from '../pages/vendor/VendorAddPriceList';
import VendorCreateBid from '../pages/vendor/VendorCreateBid';
import NotFound from '../pages/NotFound';
import ProjectDetailEdit from '../pages/vendor/ProjectDetailEdit';
import MyAccountProfile from '../pages/settings/MyAccountProfile';
import UserManagement from '../pages/UserProfilePage/UserManagement';
import NewUserManagement from "../pages/UserProfilePage/NewUserManagement";
import Error404 from '../pages/UserProfilePage/Error404';
import ProjectSettingIntendend from '../pages/settings/projectSettings/Intendend'
import EditIntendendUse from '../pages/settings/projectSettings/EditIntendedUse'
import ProjectSettingLanguagePresets from '../pages/settings/projectSettings/LanguagePresets';
 import ProjectSettingLanguageCustomCodeMapping from '../pages/settings/projectSettings/LanguageCustomCodeMapping';
import ProjectSettingPreferredVendors from '../pages/settings/projectSettings/PreferredVendors';
import ProjectSettingLanguage from '../pages/settings/projectSettings/Language';
import ProjectSettingProjectTag from '../pages/settings/projectSettings/ProjectTag';
import ReviewWorkflow from '../pages/settings/projectSettings/ReviewWorkflow';
import CreateNewReviewWorkflow from '../pages/UserProfilePage/CreateNewReviewWorkflow';
import LanguageReviewWorkflow from '../pages/settings/projectSettings/LanguageReviewWorkflow';
import ProjectSettingFuzzy from '../pages/settings/projectSettings/Fuzzy';
import ProjectSettingOneReview from '../pages/settings/projectSettings/OneReview';
import ProjectSettingEditOneReview from '../pages/settings/projectSettings/EditOneReview';
import ErrorTopology from '../pages/settings/projectSettings/ErrorTopology';
import MarketoIntegration from '../pages/UserProfilePage/MarketoIntegration';
import MachineTranslation from '../pages/UserProfilePage/MachineTranslation';
import OneTm from '../pages/UserProfilePage/OneTm';
import SystemSettingCompInformation from '../pages/settings/systemSettings/CompanyInformation';
import SystemSettingCompanyDepartment from '../pages/settings/systemSettings/CompanyDepartment';
import PurchaseOrder from '../pages/settings/systemSettings/PurchaseOrder';
import SystemSettingNDA from '../pages/settings/systemSettings/NDA';
import MarketoRestIntegrationSetting from '../pages/settings/integrationSettings/MarketoRestIntegrationSetting';
import MarketoIntegrationSetting from '../pages/settings/integrationSettings/MarketoIntegrationSetting';
import EloquaIntegrationSetting from '../pages/settings/integrationSettings/EloquaIntegrationSetting';
import BrightcoveIntegrationSetting from '../pages/settings/integrationSettings/BrightcoveIntegrationSetting';
import PardotIntegrationSetting from '../pages/settings/integrationSettings/PardotIntegrationSetting';
import VidyardIntegrationSetting from '../pages/settings/integrationSettings/VidyardIntegrationSetting';
import UberflipIntegrationSetting from '../pages/settings/integrationSettings/UberflipIntegrationSetting';
import ExactTargetIntegrationSetting from '../pages/settings/integrationSettings/ExactTargetIntegrationSetting';
import EloquaIntegration from '../pages/UserProfilePage/EloquaIntegration';
import DynamicAssets from '../components/createProject/DynamicAssets';
import StaticAssets from '../components/createProject/StaticAssets';
import ReportFile from '../pages/reports/ReportFile';
import ReportData from '../pages/reports/ReportData';
import CustomerVendor from '../pages/vendor/CustomerVendor';
import CustomVendorDirectory from '../pages/vendor/CustomVendorDirectory';
import Refrence from '../pages/UserProfilePage/Refrence';
import CreateProjectRequest from '../pages/vendor/CreateProjectRequest';
import CreateReviewWorkflow from '../pages/settings/projectSettings/CreateReviewWorkflow';
import EditReviewWorkflow from '../pages/settings/projectSettings/EditReviewWorkflow';
import Tasks from '../pages/Tasks';
import Alerts from '../pages/Alerts';
import ProjectDetailsOffline from '../pages/vendor/ProjectDetailsOffline';
import ProjectStepOffline from '../pages/vendor/ProjectStepOffline';
//import PardotIntegrationSetting from '../pages/settings/integrationSettings/PardotIntegrationSetting';
import ShowProjectRequest from '../pages/vendor/ShowProjectRequest';
import EditProjectRequest from '../pages/vendor/EditProjectRequest';
import ProjectRequestList from '../pages/vendor/ProjectRequestList';
import EditDisabledReviewWorkflow from '../pages/settings/projectSettings/EditDisabledReviewWorkflow';
import AllActivity from '../components/dashboard/AllActivity';
import ReportChanges from '../pages/reports/ReportChanges';
import Unauthorized from '../pages/Unauthorized';
import Discussion from '../pages/Discussion';
import ChangePassword from '../pages/settings/ChangePassword';
import EmailVerification from '../pages/EmailVerification';
import Reports from '../pages/reports/Reports';
import ProjectTemplates from '../pages/settings/projectSettings/ProjectTemplates';
import LeveragedTm from '../components/project/projectDetail/LeveragedTm';
import LeveragedTmView from '../components/project/projectDetail/LeverageTmView';
import HomePage from '../pages/HomePage';
import FinanceProjects from '../components/finance/FinanceProjects';
import FinanceProjectDetails from '../components/finance/ProjectDetails';
import FinanceReports from '../components/finance/Reports';
import MyAccount from '../components/finance/MyAccount';

export const RoutePaths = [
    {
        path : '/',
        element : <HomePage/>
    },
    {
        path : '/home',
        element : <HomePage/>
    },
    {
        path : '/login',
        element : <Navigate to="/dashboard"/>
    },
    {
        path : '/dashboard',
        element : <Dashboard filterType={'dashboard'}/>
    },
    {
        path : '/campaigns',
        element : <Campaign/>
    },
    {
        path: '/finance/projects',
        element : <FinanceProjects/>
    },
    {
        path: '/finance/project/:id',
        element : <FinanceProjectDetails/>
    },
    {
        path: '/finance/reports',
        element : <FinanceReports />
    },
    {
        path : '/finance/account-profile',
        element : <MyAccount />
    },
    {
        path : '/projects',
        element : <ProjectList filterType={'projects'}/>
    },
    {
        path : '/task/all',
        element : <Tasks />

    },
    {
        path : '/settings',
        element : <Settings/>
    },
    {
        path : '/createProject/:id',
        element : <CreateProject/>
    },
    {
        path : '/campaign/:id',
        element : <CampaignDetail/>
    },
    {
        path : '/campaign/:id/:tab/:tabDetailId',
        element : <CampaignDetail/>
    },
    {
        path : '/campaign-edit/:id',
        element : <CampaignEdit/>
    },
    {
        path : '/new-campaign',
        element : <NewCampaign/>
    },
    {
        path : '/vendor/:id',
        element : <Vendor/>
    },
    {
        path : '/vendor-bid-request/:id',
        element : <VendorBidRequest/>
    },{
        path :'/project/:id/review/:phaseId/:lang/:docId',
        element : <InContextPreview/>
    },
    {
        path : '/vendor-edit/:id',
        element : <VendorEdit/>
    },
    {
        path : '/vendor-add-price-list/:id',
        element : <VenderAddPriceList/>
    },
    {
        path : '/vendor-create-bid-description/:id',
        element : <VendorCreateBid/>
    },

    {    
        path : '/project/:id/:tab?',
        element : <ProjectDetail/>
    },
    {    
        path : '/project/:id/:tab/:tabId?',
        element : <ProjectDetail/>
    },
    {    
        path : '/project/:id/messages/create',
        element : <ProjectDetail/>
    },
    {    
        path : '/project/:id/language/:langCode',
        element : <ProjectDetail/>
    },
    {    
        path : '/not-found',
        element : <NotFound />
    },
    {    
        path : '/unauthorized',
        element : <Unauthorized />
    },
    {
        path : '/project-details-edit/:id',
        element : <ProjectDetailEdit/>
    },
    {
        path : '/settings/my-account-profile',
        element : <MyAccountProfile/>
    },
    {
        path : '/new-user-email-validation',
        element : <EmailVerification/>
    },
    {
        path : '/settings/myaccount/eiu',
        element : <MyAccountProfile/>
    },
    {
        path : '/settings/myaccount/eu',
        element : <MyAccountProfile/>
    },
    {
        path : '/settings/myaccount/ein',
        element : <MyAccountProfile/>
    },
    {
        path : '/change-password',
        element : <ChangePassword />
    },
    {
        path : '/settings/my-account-profile/:id',
        element : <MyAccountProfile/>
    },
    {
        path : '/settings/user-management',
        element : <UserManagement/>
    },
    {
        path : '/settings/newuser',
        element : <NewUserManagement/>
    },
    {
        path : '/404-page/:id',
        element : <Error404/>
    },
    {
        path : '/settings/project-setting-intendend',
        element : <ProjectSettingIntendend/>
    },
    {
        path : '/settings/project-setting-intendend/:id',
        element : <EditIntendendUse/>
    },
    {
        path : '/settings/project-setting-language',
        element : <ProjectSettingLanguage/>
    },
    {
        path : '/settings/project-setting-language-presets',
        element : <ProjectSettingLanguagePresets/>
    },
    {
        path : '/settings/project-setting-language-custom-code-mapping',
        element : <ProjectSettingLanguageCustomCodeMapping/>
    },
    {
        path : '/settings/project-setting-preferred-vendor',
        element : <ProjectSettingPreferredVendors/>
    },
    {
        path : '/settings/project-setting-project-tag',
        element : <ProjectSettingProjectTag/>
    },
    {
        path : '/settings/review-workflow',
        element : <ReviewWorkflow/>
    },
    {
        path : '/settings/workflow/:id',
        element : <EditReviewWorkflow/>
    },
    {
        path : '/settings/disable-workflow/:id',
        element : <EditDisabledReviewWorkflow/>
    },
    {
        path : '/settings/create-review-workflow/',
        element : <CreateReviewWorkflow/>
    },
    {
        path : '/settings/workflow/language-review-workflow/:id',
        element : <LanguageReviewWorkflow/>
    },
    {
        path : '/settings/project-setting-fuzzy',
        element : <ProjectSettingFuzzy/>
    },
    {
        path : '/settings/project-setting-onereview',
        element : <ProjectSettingOneReview/>
    },
    {
        path : '/settings/project-setting-edit-onereview/:id',
        element : <ProjectSettingEditOneReview/>
    },
    {
        path : '/settings/project-setting-error-topology',
        element : <ErrorTopology/>
    },
    {
        path : '/settings/integration-setting-marketoRest-integration',
        element : <MarketoRestIntegrationSetting/>
    },
    {
        path : '/settings/integration-setting-marketo-integration',
        element : <MarketoIntegrationSetting/>
    },
    {
        path : '/settings/integration-setting-eloqua-integration',
        element : <EloquaIntegrationSetting/>
    },
    {
        path : '/settings/integration-setting-brightcove-integration',
        element : <BrightcoveIntegrationSetting/>
    },
    {
        path : '/settings/integration-setting-pardot-integration',
        element : <PardotIntegrationSetting/>
    },
    {
        path : '/settings/integration-setting-vidyard-integration',
        element : <VidyardIntegrationSetting/>
    },
    {
        path : '/settings/integration-setting-uberflip-integration',
        element : <UberflipIntegrationSetting/>
    },
    {
        path : '/settings/integration-setting-exacttarget-integration',
        element : <ExactTargetIntegrationSetting/>
    },
    {
        path : '/settings/integration-setting-machine-translation-integration',
        element : <MachineTranslation/>
    },
    {
        path : '/one-tm',
        element : <OneTm/>,
        permission : 'TM_READ_EDIT'
    },
    {
        path : '/reference',
        element : <Refrence/>,
        permission : 'GLOSSARY_READ'
    },
    
    {
        path : '/settings/system-setting-company-information',
        element : <SystemSettingCompInformation/>
    },
    {
        path : '/settings/system-setting-company-department',
        element : <SystemSettingCompanyDepartment/>
    },
    {
        path : '/settings/project-templates',
        element : <ProjectTemplates/>
    },
    {
        path : '/settings/purchase-order',
        element : <PurchaseOrder/>
    },
    {
        path : '/settings/system-setting-NDA/',
        element : <SystemSettingNDA/>
    },
    {
        path : '/settings/eloqua-integration/:id',
        element : <EloquaIntegration/>

    },
    {
        path : '/createProject/dynamic-assets/:id',
        element : <DynamicAssets/>
    },
    {
        path : '/createProject/static-assets/:id',
        element : <StaticAssets/>
    },
    {
        path : '/reports',
        element : <Reports/>
    },
    {
        path : '/reports-old',
        element : <ReportChanges/>
    },
    {
        path : '/reports/data/:id',
        element : <ReportData/>
    },
    {
        path : '/vendor/customer-vendor/',
        element : <CustomerVendor/>
    },
    {
        path : '/vendors/:id',
        element : <CustomVendorDirectory/>
    },
    {
        path : '/vendor/project-offline/:id',
        element : <ProjectDetailsOffline/>
    },
    {
        path : '/vendor/project-step-offline/:id',
        element : <ProjectStepOffline/>
    },
    {
        path : '/project-request/create',
        element : <CreateProjectRequest/>
    },
    {
        path : '/project-request/show/:id',
        element : <ShowProjectRequest/>
    },
    {
        path : '/project-request/edit/:id',
        element : <EditProjectRequest/>
    },
    {
        path : '/project-request/list',
        element : <ProjectRequestList filterType={'projects-request-list'}/>
    },
    { 
        path : '/alerts',
        element : <Alerts/>
    },
    {
        path : '/dashboard/all-activity',
        element : <AllActivity/>
    },
    {
        path : '/reports/report-changes/:id',
        element : <ReportChanges/>
    },
    {
        path : '/discussions',
        element : <Discussion/>
    },
    {
        path : '/leveraged-tm/:id/:projectAssetId/:targetLanguage',
        element : <LeveragedTmView/>
    }
];


